import { FormFooter } from 'common/components/drawer';
import { Button } from 'reactstrap';

const Footer = ({ drawer, disabled, submit, isCreating }) => {
  return (
    <FormFooter>
      <Button
        color="cancel"
        className="px-0 py-1 me-4"
        onClick={() => {
          drawer.close();
        }}
        disabled={disabled}
      >
        CANCEL
      </Button>
      <Button onClick={submit} disabled={disabled} color="primary" className="px-4">
        {isCreating ? 'CREATE' : 'UPDATE'}
      </Button>
    </FormFooter>
  );
};

export default Footer;
